import React, {FC} from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

interface CustomMarkdownType {
    initialText: string;
}

const CustomMarkdown: FC<CustomMarkdownType> = ({initialText}) => {
    if (initialText) {
        return (
            <Markdown
                remarkPlugins={[remarkBreaks, remarkGfm]}
                components={{
                    a: (props: any) => {
                        if (!props.href) return null;
                        return (
                            <a href={props.href} target="_blank" rel="noreferrer">
                                {props.children}
                            </a>
                        );
                    },
                }}
            >
                {initialText.replace(/(?<=\n\n)(?![*-])\n/g, '&nbsp;\n ')}
            </Markdown>
        );
    }
    return null;
};

export default CustomMarkdown;
